export const THEME_STORAGE_KEY='sousa-murray-crm-theme';
export const THEME_OPTIONS=['light','dark','system'];

const valid=value=>THEME_OPTIONS.includes(value)?value:'system';
const systemQuery=()=>typeof window!=='undefined'&&window.matchMedia?window.matchMedia('(prefers-color-scheme: dark)'):null;

export function getThemePreference(){
  if(typeof window==='undefined')return'system';
  try{return valid(window.localStorage.getItem(THEME_STORAGE_KEY));}catch{return'system';}
}

export function resolveTheme(preference=getThemePreference()){
  const mode=valid(preference);
  if(mode==='system')return systemQuery()?.matches?'dark':'light';
  return mode;
}

export function applyTheme(preference=getThemePreference()){
  const mode=valid(preference),resolved=resolveTheme(mode);
  if(typeof document!=='undefined'){
    const root=document.documentElement;
    root.dataset.theme=resolved;
    root.dataset.themePreference=mode;
    root.style.colorScheme=resolved;
  }
  return{preference:mode,resolved};
}

export function setThemePreference(preference){
  const mode=valid(preference);
  if(typeof window!=='undefined'){
    try{window.localStorage.setItem(THEME_STORAGE_KEY,mode);}catch{}
  }
  const state=applyTheme(mode);
  if(typeof window!=='undefined')window.dispatchEvent(new CustomEvent('crm-theme-change',{detail:state}));
  return state;
}

let systemListenerReady=false;
export function initialiseTheme(){
  const state=applyTheme();
  if(systemListenerReady)return state;
  const query=systemQuery();
  if(query){
    const changed=()=>{
      if(getThemePreference()!=='system')return;
      const next=applyTheme('system');
      window.dispatchEvent(new CustomEvent('crm-theme-change',{detail:next}));
    };
    query.addEventListener?.('change',changed);
    query.addListener?.(changed);
    systemListenerReady=true;
  }
  return state;
}
